import { BASE_URL } from "../../utils/requestUtils";

export interface ChatbotResponse {
  message_id: number;
  user_message: string;
  bot_response: string;
  user_message_timestamp: string;
  bot_response_timestamp: string;
  feedback: string;
  agent_chat_active?: boolean;
  agent_handoff_offered?: boolean;
  agent_chat_engaged?: boolean;
}

export interface ChatHistoryMessage {
  id: string;
  sender_type: "patient" | "bot" | "agent" | "system";
  sender_name: string;
  body: string;
  sent_at: string;
  feedback?: string;
  is_agent_handoff_offer?: boolean;
}

export type AgentChatStatus = "connected" | "connecting" | "disconnected";

export interface ChatHistoryResponse {
  agent_chat_status: AgentChatStatus;
  agent_chat_engaged?: boolean;
  messages: ChatHistoryMessage[];
}

export const sendChatMessage = async (
  user_message: string,
  accessToken: string,
  feedback?: string,
): Promise<Response> =>
  fetch(`${BASE_URL}/api/v1/chatbot_message/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ user_message, feedback }),
  });

export const sendAgentChatMessage = async (
  user_message: string,
  accessToken: string,
  idempotencyKey: string,
): Promise<Response> =>
  fetch(`${BASE_URL}/api/v1/agent_chat_messages/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ user_message, idempotency_key: idempotencyKey }),
  });

export const startAgentHandoff = async (
  accessToken: string,
): Promise<Response> =>
  fetch(`${BASE_URL}/api/v1/agent_chat_conversations/start/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });

export const endAgentHandoff = async (accessToken: string): Promise<Response> =>
  fetch(`${BASE_URL}/api/v1/agent_chat_conversations/end/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });

export const fetchChatHistory = async (
  accessToken: string,
): Promise<Response> =>
  fetch(`${BASE_URL}/api/v1/chatbot_message/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
